import React from 'react';
import { Clock, ChevronLeft, ChevronRight } from 'lucide-react';
import { EARTH } from '../theme/constants';

export function ChangeLogPanel({ isOpen, onToggle, changeLog }) {
  if (!isOpen) return null;

  return (
    <div className="fixed right-0 top-0 h-full w-72 shadow-xl z-20 flex flex-col" style={{ backgroundColor: '#fff', borderLeft: '1px solid ' + EARTH.stone[200] }}>
      <div className="flex items-center justify-between p-4 border-b" style={{ borderColor: EARTH.stone[200], backgroundColor: EARTH.sage[50] }}>
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5" style={{ color: EARTH.sage[600] }} />
          <h3 className="font-semibold" style={{ color: EARTH.sage[800] }}>Change Log</h3>
        </div>
        <button onClick={onToggle} className="p-1 rounded" style={{ color: EARTH.stone[500] }}>
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4">
        {changeLog.length === 0 ? (
          <p className="text-sm text-center py-8" style={{ color: EARTH.stone[400] }}>No changes yet</p>
        ) : (
          <div className="space-y-2">
            {changeLog.map(l => (
              <div key={l.id} className="p-3 rounded-lg" style={{ backgroundColor: EARTH.stone[50] }}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium" style={{ color: EARTH.stone[700] }}>{l.user}</span>
                  <span className="text-xs" style={{ color: EARTH.stone[400] }}>{l.timestamp}</span>
                </div>
                <p className="text-sm" style={{ color: EARTH.stone[600] }}>{l.action}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
